import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styled from 'styled-components';

const QuillWrapper = styled.div`
    .ql-toolbar {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: transparent;
        border: none;
        padding: 8px;
        position: sticky;
        top: 0;
        z-index: 1;
    }

    .ql-container {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        background: transparent;
        border: none;
        min-height: 100px;
        max-height: 300px; /* Limit height for scroll */
        overflow-y: auto;
    }

    .ql-editor {
        color: #fff;
        min-height: 100px;
        padding: 12px 15px;
    }

    .ql-editor.ql-blank::before {
        color: rgba(255, 255, 255, 0.5);
    }

    .ql-snow .ql-stroke {
        stroke: rgba(255, 255, 255, 0.7);
    }

    .ql-snow .ql-fill {
        fill: rgba(255, 255, 255, 0.7);
    }

    .ql-snow .ql-picker {
        color: rgba(255, 255, 255, 0.7);
    }

    .ql-snow .ql-picker-label:hover,
    .ql-snow .ql-picker-item:hover {
        color: #fff;
    }

    .ql-snow .ql-active .ql-stroke,
    .ql-snow .ql-active .ql-fill {
        stroke: #0079BF;
        fill: #0079BF;
    }

    .ql-snow .ql-tooltip {
        background-color: #3a4047;
        color: #fff;
        border: none;
        border-radius: 4px;
    }

    .ql-snow .ql-tooltip a.ql-action:hover {
        color: #0079BF;
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action {
        margin-right: 8px;
    }

    .ql-snow .ql-tooltip input[type=text] {
        background: #282E33;
        border: 1px solid rgba(255, 255, 255, 0.2);
        color: #fff;
        padding: 4px 8px;
        border-radius: 4px;
    }

    .ql-snow .ql-tooltip input[type=text]::placeholder {
        color: rgba(255, 255, 255, 0.5);
    }

    .ql-snow .ql-tooltip a {
        color: #0079BF;
    }
`;

const StyledQuill = React.forwardRef(function StyledQuill(props, ref) {
    return (
        <QuillWrapper>
            <ReactQuill ref={ref} {...props} />
        </QuillWrapper>
    );
});

export default StyledQuill;
